<crm-multi-select
  [filtersUiVersion]="filtersUiVersion"
  #multiSelectComponent
  [options]="entities"
  [selectedItems]="_selectedEntities"
  (selectedItemsChange)="onSelect($event)"
  (panelShow)="onShowPanel()"
  (onFilter)="search($event.filter)"
  [showToggleAll]="true"
  [virtualScroll]="true"
  [virtualScrollItemSize]="50"
  scrollHeight="300px"
  panelStyleClass="crm-contragent-multi-select-panel"
  [class]="class + (isError ? ' ng-invalid ng-dirty' : '')"
  [styleClass]="styleClass + (isError ? ' ng-invalid ng-dirty' : '')"
  [label]="label"
  [disabled]="disabled"
  [appendTo]="appendTo"
  [showClear]="showClear"
  [placeholder]="placeholder"
  [loading]="selectionLoading"
  [sort]="''"
  filterBy="name,inn">
  <ng-template
    #selectedItemsTemplate
    let-contragents="items">
    <ng-container *ngFor="let contragent of contragents; last as isLast">
      <ng-container *ngIf="toContragent(contragent) as contragent">
        <span [innerHTML]="highlightMatchText(contragent.name) | safeHtml"></span>
        {{ isLast ? '' : ', ' }}
      </ng-container>
    </ng-container>
  </ng-template>
  <ng-template
    #itemTemplate
    let-contragent="item">
    <ng-container *ngIf="toContragent(contragent) as contragent">
      <div>
        <div>
          <span [innerHTML]="highlightMatchText(contragent.name) | safeHtml"></span>
        </div>
        <div
          *ngIf="contragent.inn"
          class="frm-color-green">
          ИНН:
          <span [innerHTML]="highlightMatchText(contragent.inn) | safeHtml"></span>
        </div>
        <div
          *ngIf="contragent.kpp"
          class="text-gray-500">
          КПП: {{ contragent.kpp }}
        </div>
      </div>
    </ng-container>
  </ng-template>

  <ng-template #footerTemplate>
    <crm-spinner
      *ngIf="paginationLoading"
      top=""
      text=""
      [height]="35"
      [width]="35"
      bottom=""></crm-spinner>
  </ng-template>
</crm-multi-select>
